import { TaskFormDialog } from '../task-dialog/TaskFormDialog'

export function DialogProvider({ children }: { children: React.ReactNode }) {
  return (
    <>
      {children}
      <TaskFormDialog />
    </>
  )
}
